import React from 'react'
// Import CommonBanner Area
import CommonBanner from '../component/Common/CommonBanner'
// import Founder Area
import Founder from '../component/Founder'
import TeamArea from '../component/Team'

import HeartbeatSection from '../component/Home/HeartbeatSection'
const FounderPage = () => {
  return (
    <>
      {/* <CommonBanner heading="Meet Our Founder" pagination="Founder"/> */}
      <Founder/>

           <TeamArea/>
                  <HeartbeatSection/>
    </>
  )
}

export default FounderPage